import {Modal, Switch} from 'antd'
import {getId} from 'apis/model/base'
import {showConfirm} from 'components/Feed/TimeLineFeed'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo, useState} from 'react'
import {BsGrid, BsInboxesFill, BsUiRadiosGrid} from 'react-icons/bs'
import {NullAsDefault, pagerControls, renderSelf} from 'views/Shared'
import {
    renderCourseSubjectCard,
    renderCourseSubjectChip
} from '../../../../Workspace/Course/functions/renderCourseSubject'
import EntityList from '../../../EntityList'
import {notifyOnError} from '../../../factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from '../../../factory/createNotification'
import {bindQueryParam} from '../../../functions/routerHelper'
import {createNumberControlledInput} from "../../../factory/createFormField";
import {Formik} from "formik";
import {shallowDiff} from "../../../../Shared";
import {FormActionGroups} from "../../../../../components/form/FormActionBar";
import FieldsFactory from "../../../../../components/form/FieldsFactory";
import {
    course_getAvailSubjectsForCourseClass_Api,
    course_linkSubjectToCourseClass_Api,
    course_unlinkSubjectToCourseClass_Api
} from "../../../../../apis";
import Translate from "../../../../../modules/local/Translate";
import LookupField from "../../../../../components/LookupField";
import {createValue} from "../../../../../components/form/utils";
import {getType} from "../../../../../apis/model/base";
import {compose, mapProps} from "recompose";
import withTranslate from "../../../../../modules/local/withTranslate";
import {ActionModalWrapper} from "../../../../../components/form/ActionModalWrapper";
import LoadingBlock from "../../../../Loading/LoadingBlock";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";

const subject_actions = {
    link: {label: 'selected', value: 1, action: 'active'},
    unLink: {label: 'no', value: 0, action: 'inactive'},
}

function confirmAction(params) {
    const {title, content, Icon = NullAsDefault} = params ?? {}
    showConfirm({
        icon: Icon,
        okButtonProps: {
            type: 'primary',
            className: 'rounded-lg no-shadow no-text-shadow no-border',
        },
        cancelButtonProps: {
            type: 'default',
            className: 'rounded-lg no-shadow no-text-shadow no-border text-color-400',
        },
        title: {title},
        content: {content},
        ...(params ?? {}),
    })
}


export const formSchema = {
    is_mandatory: {
        inline: true,
        className: 'flex justify-end',
        title: 'is mandatory',
        children: [
            {
                name: 'is_mandatory',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate: t}) => ({
                        name,
                        checked: !!value,
                        style: {width: 'auto'},
                        checkedChildren: t('mandatory'),
                        unCheckedChildren: t('optional'),
                        className: 'justify-end',
                        onChange: (value) => {
                            onChange(createValue(name, Number(value ?? 0)))
                        },
                    }))
                )(Switch),
            },
        ],
    },
    number_of_credits: {
        title: 'number of credits',
        children: [
            {
                name: 'number_of_credits',
                component: createNumberControlledInput({
                    placeholder: 'number of credits',
                }),
            },
        ],
    },
    number_of_sessions: {
        title: 'number of sessions',
        children: [
            {
                name: 'number_of_sessions',
                component: createNumberControlledInput({
                    placeholder: 'number of sessions',
                }),
            },
        ],
    },
    passed_score: {
        title: 'passed score',
        children: [
            {
                name: 'passed_score',
                component: createNumberControlledInput({
                    placeholder: 'passed score',
                    defaultValue: 5,
                }),
            },
        ],
    },
    passed_attendance_percentage: {
        title: 'passed attendance percentage',
        children: [
            {
                name: 'passed_attendance_percentage',
                component: createNumberControlledInput({
                    placeholder: 'passed attendance percentage',
                    defaultValue: 60,
                    addonBefore: (
                        <Translate>
                            {(t) => (
                                <span className="font-medium text-sm text-color-400 italic">
                      {`${t('percent')} (%)`}
                    </span>
                            )}
                        </Translate>
                    ),
                }),
            },
        ],
    },
    group_name: {
        title: 'group name',
        children: [
            {
                name: 'group_name',
                component: ({name, value, onChange, form}) => {
                    const values = _.get(form, 'values', {})
                    const owner = _.get(values, 'subject.owner', {})
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    createIfNotExists={true}
                                    defaultValue={
                                        values?.group_name
                                    }
                                    apiPath={`/lookup/${getType(owner)}/${getId(owner)}/field/course_subject_group_name/gets`}
                                    name={name}
                                    placeholder={t('choose or create')}
                                    handleChange={(e) => {
                                        onChange(
                                            createValue('group_name', e.target.value)
                                        )
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
}


export const SubjectInCourseClassEditForm = ({
                                                 onCancel = NullAsDefault,
                                                 onSubmit = NullAsDefault,
                                                 initialValues = {},
                                             }) => {
    const t = useTranslate()

    const [current, setCurrent] = useState('overview')

    const _initialValues = useMemo(() => {
        const {...rest} = initialValues ?? {}
        return {
            is_mandatory: 0,
            ...rest
        }
    }, [initialValues])

    const validate = (values) => {
        let errors = {}

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, _initialValues)
                const {...rest} = changes ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest
                        },
                        _.isUndefined
                    )
                )
            }}>
            <React.Fragment>
                <div className="mb-3 text-sm text-color-400 italic">
                    {`* ${t('update course subject description')}`}
                </div>
                <ActionModalWrapper
                    action={
                        <FormActionGroups
                            submitProps={{
                                label: 'save',
                            }}
                        />
                    }>
                    <FieldsFactory
                        formSchema={[]}
                    />
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}

export const CourseClassSubjectList = ({
                                           item,
                                           header = null,
                                           controls = pagerControls,
                                           renderFooter = renderSelf,
                                       }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const [refreshToken, setRefreshToken] = useState()

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const apiInfo = course_getAvailSubjectsForCourseClass_Api

    const {keyword, component: search_widget} = controls?.search ?? {}

    const course_class_id = getId(item)

    const refreshKey = useMemo(
        () =>
            [
                apiInfo.path.replace(':id', course_class_id),
                JSON.stringify(keyword),
                refreshToken,
            ].join(','),
        [course_class_id, keyword, refreshToken]
    )

    const onError = notifyOnError(t)

    const refresh = () => {
        setRefreshToken(Date.now())
    }

    const {handleAsyncAction: addSubject} = useAsyncAction({
        apiInfo: course_linkSubjectToCourseClass_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            refresh()
        },
    })

    const {handleAsyncAction: removeSubject} = useAsyncAction({
        apiInfo: course_unlinkSubjectToCourseClass_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            refresh()
        },
    })

    const handleAction = (action, params) => {
        switch (action) {
            case subject_actions.link.action:
                const {course_class, subject} = params ?? {}
                confirmAction({
                    Icon: <BsUiRadiosGrid style={{color: '#48bb78'}} className="anticon"/>,
                    okText: t('choose'),
                    cancelText: t('ignore'),
                    title: (
                        <span className="font-bold text-color-000">{t('choose subject')}</span>
                    ),
                    content: (
                        <span className="text-color-500 italic">
              {t('are you sure you want to choose this course class')}
            </span>
                    ),
                    onOk: () => {
                        addSubject(
                            {},
                            {course_class_id: getId(course_class), subject_id: getId(subject)}
                        )
                    },
                })
                break
            case subject_actions.unLink.action:
                const course_subject_id = params?.id
                if (course_subject_id) {
                    confirmAction({
                        Icon: <BsGrid style={{color: 'var(--color-primary-300)'}} className="anticon"/>,
                        okText: t('sure'),
                        cancelText: t('ignore'),
                        title: (
                            <span className="font-bold text-color-000">{t('deselect subjects')}</span>
                        ),
                        content: (
                            <span className="text-color-500 italic">
                {t('are you sure you want to deselect subjects of class')}
              </span>
                        ),
                        onOk: () => {
                            removeSubject({}, {id: course_subject_id})
                        },
                    })
                }
                break
            default:
                break
        }
    }

    const renderActions = (item) => {
        return (
            <div className="flex flex-center gap-x-3">
                <Switch
                    size={isLg ? 'default' : 'small'}
                    // className="custom-switch-xs"
                    checked={Number(!!item?.is_linked)}
                    // checkedChildren={t(subject_actions.link.label)}
                    // unCheckedChildren={t(subject_actions.unLink.label)}
                    onChange={(value) => {
                        const current = _.find(subject_actions, {
                            value: Number(value),
                        })
                        handleAction(current?.action, item)
                    }}
                />
            </div>
        )
    }

    const modal = useMemo(() => {
        let title
        let Content = NullAsDefault
        let params = {title: undefined}
        let modal_params = {}
        let Wrapper = ({children}) => children({item: {}});
        switch (action?.type) {
            default:
                break
        }
        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{item}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action])

    return (
        <ActionModalWrapper className="flex-1">
            {header}
            <div className="flex flex-col flex-1">
                <h3 className="font-bold text-base text-slate-600 tracking-wide">
                    {t('subjects')} ({_.get(item, 'class_subjects', []).length})
                </h3>
                <div style={{ height: 3 }} className="my-1 w-20 rounded-full bg-gray-400"/>
            </div>
            <div className="flex flex-col gap-4 flex-1">
                {search_widget}
                <div className="flex flex-col">
                    <EntityList
                        key={refreshKey}
                        apiInfo={apiInfo}
                        values={{keyword}}
                        refreshKey={refreshKey}
                        RenderEntity={React.Fragment}
                        PaginationMeta={NullAsDefault}
                        query={bindQueryParam({id: course_class_id})}
                        renderItem={renderCourseSubjectCard({renderActions, handleAction})}
                        renderWrap={(children) => (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                {children}
                            </div>
                        )}
                        renderEmpty={() => (
                            <div className="p-6 flex flex-col items-center gap-3 border border-color-50 rounded-xl shadow-md">
                                <BsInboxesFill size={40} style={{ color: '#dedede' }}/>
                                <span className="text-center text-sm text-color-300 tracking-wider italic">
                                        {t('no data is available now')}
                                    </span>
                            </div>
                        )}
                    />
                </div>
            </div>
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}

// Chip-select môn học của Lớp, dùng ở tab "Cấu hình Lớp học" (CourseClassDetail.js, case
// 'settings') - THAY cho tab "Môn học" cũ (đã bỏ, xem CourseClassDetail.js). Tái dùng NGUYÊN api
// course_getAvailSubjectsForCourseClass_Api (đã lọc theo môn của Khóa + cờ is_linked, xem
// SubjectController::getAvailSubjectsForCourseClass) và 2 api link/un-link - chỉ đổi phần hiển thị
// (chip thay vì thẻ+Switch) + bỏ dialog xác nhận (chip bấm là đổi ngay, không phải hành động cần
// cân nhắc như xoá). KHÔNG đụng tới CourseClassSubjectList phía trên - component đó vẫn được các
// màn khác dùng nguyên (CourseClasses.js, CourseHelpers.js, CourseClassPanelDetail.js,
// useCourseClassForm.js).
export const CourseClassSubjectChips = ({item}) => {
    const t = useTranslate()
    const [refreshToken, setRefreshToken] = useState()
    const [pendingId, setPendingId] = useState()

    const apiInfo = course_getAvailSubjectsForCourseClass_Api
    const course_class_id = getId(item)

    const refreshKey = useMemo(
        () => [apiInfo.path.replace(':id', course_class_id), refreshToken].join(','),
        [course_class_id, refreshToken]
    )

    const onError = notifyOnError(t)
    const refresh = () => setRefreshToken(Date.now())

    const {handleAsyncAction: addSubject} = useAsyncAction({
        apiInfo: course_linkSubjectToCourseClass_Api,
        onError: (...args) => {
            setPendingId(undefined)
            onError(...args)
        },
        onSuccess: () => {
            setPendingId(undefined)
            refresh()
        },
    })

    const {handleAsyncAction: removeSubject} = useAsyncAction({
        apiInfo: course_unlinkSubjectToCourseClass_Api,
        onError: (...args) => {
            setPendingId(undefined)
            onError(...args)
        },
        onSuccess: () => {
            setPendingId(undefined)
            refresh()
        },
    })

    const onToggle = (subjectItem) => {
        const {id, is_linked, subject} = subjectItem ?? {}
        setPendingId(id)
        if (is_linked) {
            removeSubject({}, {id})
        } else {
            addSubject({}, {course_class_id, subject_id: getId(subject)})
        }
    }

    if (!course_class_id) return null

    return (
        <div className="flex flex-col gap-2">
            <EntityList
                key={refreshKey}
                apiInfo={apiInfo}
                refreshKey={refreshKey}
                RenderEntity={React.Fragment}
                PaginationMeta={NullAsDefault}
                query={bindQueryParam({id: course_class_id})}
                renderItem={renderCourseSubjectChip({
                    onToggle,
                    isPending: (subjectItem) => subjectItem?.id === pendingId,
                })}
                renderWrap={(children) => (
                    <div className="flex flex-wrap gap-2">{children}</div>
                )}
                renderEmpty={() => (
                    <span className="text-sm text-color-300 italic tracking-wide">
                        {t('no data is available now')}
                    </span>
                )}
            />
        </div>
    )
}
